export class AANFaqDrawer {
	init(): void {
		const faqDrawers: HTMLElement[] = Array.from(document.querySelectorAll(".faq-drawer"));
		faqDrawers.forEach(faqDrawer => {
			const header = faqDrawer.querySelector("header") as HTMLElement;
			const list = faqDrawer.querySelector(".list") as HTMLElement;
			const footer = faqDrawer.querySelector("footer") as HTMLElement;

			header.addEventListener("click", () => this.slideToggle(list));
			footer.addEventListener("click", () => this.slideToggle(list));
		});
	}

	private slideUp (target: HTMLElement, duration = 500) {
		target.style.transitionProperty = "height, margin, padding";
		target.style.transitionDuration = duration + "ms";
		target.style.height = target.offsetHeight + "px";
		// Not sure why this is needed, but unless it is here this breaks for all browsers.
		// eslint-disable-next-line no-unused-expressions
		target.offsetHeight;
		target.style.overflow = "hidden";
		target.style.height = "0";
		target.style.paddingTop = "0";
		target.style.paddingBottom = "0";
		target.style.marginTop = "0";
		target.style.marginBottom = "0";
		window.setTimeout(() => {
			target.style.display = "none";
			target.style.removeProperty("height");
			target.style.removeProperty("padding-top");
			target.style.removeProperty("padding-bottom");
			target.style.removeProperty("margin-top");
			target.style.removeProperty("margin-bottom");
			target.style.removeProperty("overflow");
			target.style.removeProperty("transition-duration");
			target.style.removeProperty("transition-property");
		}, duration);
	};

	private slideDown (target: HTMLElement, duration = 500) {
		target.style.removeProperty("display");
		let display = window.getComputedStyle(target).display;

		if (display === "none") {
			display = "block";
		}

		target.style.display = display;
		const height = target.offsetHeight;
		target.style.overflow = "hidden";
		target.style.height = "0";
		target.style.paddingTop = "0";
		target.style.paddingBottom = "0";
		target.style.marginTop = "0";
		target.style.marginBottom = "0";
		// eslint-disable-next-line no-unused-expressions
		target.offsetHeight;
		target.style.transitionProperty = "height, margin, padding";
		target.style.transitionDuration = duration + "ms";
		target.style.height = height + "px";
		target.style.removeProperty("padding-top");
		target.style.removeProperty("padding-bottom");
		target.style.removeProperty("margin-top");
		target.style.removeProperty("margin-bottom");
		window.setTimeout(() => {
			target.style.removeProperty("height");
			target.style.removeProperty("overflow");
			target.style.removeProperty("transition-duration");
			target.style.removeProperty("transition-property");
		}, duration);
	};

	private slideToggle(target: HTMLElement, duration = 500) {
		if (window.getComputedStyle(target).display === "none") {
			return this.slideDown(target, duration);
		} else {
			return this.slideUp(target, duration);
		}
	};
}

document.addEventListener("DOMContentLoaded", () => {
	const faqDrawer = new AANFaqDrawer();

	faqDrawer.init();
});
